import { createEntityAdapter } from '@reduxjs/toolkit';
import { TourneyImageEntity } from 'modules/tourneys/ui/components/tourneys-images-upload';

export const tourneysImageEntitiesAdapter =
  createEntityAdapter<TourneyImageEntity>();
